import {
  all,
  call,
  put,
  takeEvery,
  takeLatest,
  takeLeading,
} from 'redux-saga/effects';
import {
  DO_ADD_TO_CART_REQUEST,
  DO_CREATE_ORDER_REQUEST,
  DO_FETCH_CART_REQUEST,
  DO_FETCH_LOGGED_OUT_CART_REQUEST,
  DO_OFFLINE_CART_REQUEST,
  DO_REMOVE_FROM_CART_REQUEST,
} from '../../constant/checkout';
import {
  addToCartRequest,
  createOrderRequest,
  getCartInfoRequest,
  getCartInfoRequest2,
  removeToCartRequest,
} from '../../../api/checkout';
import {
  createNotification,
  NOTIFICATION_TYPE,
} from '../../../services/Notification';
import { errorHandler } from '../../../utils/helpers';
import { doFetchCartSuccess, setIsLoading } from '../../action/checkout';
import { setPaymentIsInProgress } from '../../action/common';
import { SEGMENT_EVENTS, trackEvent } from '../../../utils/Segment';
import { LOCAL_STORAGE_CONSTANT } from '../../../constants/app';
import { getItem } from '../../../utils/cache';
import { extractJSON } from '../../../services/jsonUtil';

function* addToCart({ payload }) {
  const { product } = payload || {};
  trackEvent(SEGMENT_EVENTS.PRODUCT_ADD_TO_CART, {
    product_id: product.id,
    product_name: product.name || product.title,
    amount: product.amount,
  });
  yield put(setIsLoading(true));
  try {
    const response = yield call(addToCartRequest, product.id);
    // const response = yield call(getCartInfoRequest);
    yield put(doFetchCartSuccess(response?.data?.response?.data));
    createNotification({
      type: NOTIFICATION_TYPE.SUCCESS,
      message: 'Product added to cart successfully',
    });
  } catch (error) {
    console.error('ERROR:', error);
    createNotification(errorHandler(error));
  }
  yield put(setIsLoading(false));
}

function* OfflineCart({ payload }) {
  const { product } = payload || {};
  trackEvent(SEGMENT_EVENTS.PRODUCT_ADD_TO_CART, {
    product_id: product.id,
    product_name: product.name || product.title,
    amount: product.amount,
  });
  yield put(setIsLoading(true));
  try {
    yield call(addToCartRequest, product.id);
    createNotification({
      type: NOTIFICATION_TYPE.SUCCESS,
      message: 'Product added to cart successfully',
    });
  } catch (error) {
    console.error('ERROR:', error);
    createNotification(errorHandler(error));
  }
  yield put(setIsLoading(false));
}

function* removeFromCart({ payload }) {
  const { product } = payload || {};
  trackEvent(SEGMENT_EVENTS.PRODUCT_REMOVE_FROM_CART, {
    product_id: product.id,
    product_name: product.name,
    amount: product.amount,
  });
  yield put(setIsLoading(true));
  try {
    const response = yield call(removeToCartRequest, product.id);
    // const response = yield call(getCartInfoRequest);
    yield put(doFetchCartSuccess(response?.data?.response?.data));
  } catch (error) {
    console.error('ERROR:', error);
    createNotification(errorHandler(error));
  }
  yield put(setIsLoading(false));
}

function* fetchCart() {
  yield put(setIsLoading(true));
  try {
    const response = yield call(getCartInfoRequest);
    yield put(doFetchCartSuccess(response?.data?.response?.data));
  } catch (error) {
    console.error('ERROR:', error);
    createNotification(errorHandler(error));
  } finally {
    yield put(setIsLoading(false));
  }
}

function* fetchLoggedOutCart() {
  yield put(setIsLoading(true));
  try {
    const response = yield call(getCartInfoRequest2);
    yield put(doFetchCartSuccess(response?.data?.response?.data));
  } catch (error) {
    console.error('ERROR:', error);
    createNotification(errorHandler(error));
  } finally {
    yield put(setIsLoading(false));
  }
}

function* createOrder() {
  const sessiondata = JSON.parse(getItem(LOCAL_STORAGE_CONSTANT.SESSION));
  const provider = sessiondata?.provider;
  const isAppleLogin = getItem('isAppleLogin');

  yield put(setPaymentIsInProgress(true));
  trackEvent(SEGMENT_EVENTS.CREATE_ORDER);
  try {
    let params;
    if (getItem(LOCAL_STORAGE_CONSTANT.FB_CLID)) {
      params = {
        fbc: getItem(LOCAL_STORAGE_CONSTANT.FB_CLID),
      };
    }
    const userData = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
    let isNewUser = false;
    try {
      const user = userData;
      isNewUser =
        user?.attributes
          ?.new_user /* && !user?.attributes?.onboarding_completed */;
    } catch (e) {
      isNewUser = false;
    }
    const hasOfflineCardAndIsNewUser =
      JSON.parse(getItem('isOfflineCheckout')) && isNewUser;
    const isGoogleUserWithoutOnboarding =
      provider === 'google' && !userData?.attributes?.onboarding_completed;

    const isAppleUserWithoutOnboarding =
      isAppleLogin && !userData?.attributes?.onboarding_completed;

    if (
      hasOfflineCardAndIsNewUser ||
      isGoogleUserWithoutOnboarding ||
      isAppleUserWithoutOnboarding
    ) {
      params = {
        ...params,
        page: 'assessment',
      };
    }

    const response = yield call(createOrderRequest, params);
    const url = response?.data?.response?.data?.url || response?.data?.response;
    if (url) {
      window.location.assign(url);
    }
  } catch (error) {
    console.error('ERROR:', error);
    yield put(setPaymentIsInProgress(false));
    createNotification(errorHandler(error));
    window.location.href = '/home';
  }
}

/**
 * Watch checkout actions
 * */
export default function* checkoutSaga() {
  yield all([
    takeLeading(DO_ADD_TO_CART_REQUEST, addToCart),
    takeLeading(DO_REMOVE_FROM_CART_REQUEST, removeFromCart),
    takeLatest(DO_FETCH_CART_REQUEST, fetchCart),
    takeLeading(DO_FETCH_LOGGED_OUT_CART_REQUEST, fetchLoggedOutCart),
    takeLeading(DO_CREATE_ORDER_REQUEST, createOrder),
    takeEvery(DO_OFFLINE_CART_REQUEST, OfflineCart),
  ]);
}
